import { formatAlt } from './formatAlt'

interface Props {
  alt: string
}

export function formatAltItems(items: Props[]) {
  return items?.map((item) => {
    return {
      ...item,
      alt: formatAlt(item?.alt).altFormat,
      altData: item?.alt,
    }
  })
}
